const state = {
  visible: false,
  miniSize: false
}

const getters = {
  isVisible: (state) => (state.visible),
  isMini: (state) => (state.miniSize)
}

const mutations = {
  visible: (state, val) => (state.visible = val),
  toggleSize: (state) => (state.miniSize = !state.miniSize)
}

const actions = {
  show: ({ commit }) => commit('visible', true),
  hide: ({ commit }) => commit('visible', false),
  toggleSize: ({ commit }) => commit('toggleSize')
}

export default {
  state,
  getters,
  mutations,
  actions
}
